import React, { useState, useEffect } from "react";
import { CChart } from '@coreui/react-chartjs';

function DiskGraph(props) {
  const [data, setData] = useState();
  const [diskArray, setDiskArray] = useState([]);
  const [timeArray, setTimeArray] = useState([]);
  const [thresholdArray, setThresholdArray] = useState([]);

  useEffect(() => {
    var disk = [];
    var times = [];
    var th = [];
    var threshold = props.threshold;
    setTimeArray(times);
    setData(props.data);

    props.data.forEach(element => {
      disk.push(element.disk);
      times.push(element.time);
      th.push(threshold);
    });
    setDiskArray(disk);
    setTimeArray(times);
    setThresholdArray(th);

  }, [props]);

  const options = {
    maintainAspectRatio: false,
    animation: {
      duration: 0
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    }
  }

  const line = {
    labels: timeArray,
    datasets: [
      {
        label: 'Disk Usage in %',
        fill: true,
        lineTension: 0.1,
        backgroundColor: 'rgba(61,89,197,0.4)',
        borderColor: 'rgba(61,89,197,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(61,89,197,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(61,89,197,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 1,
        data: diskArray,
      },{
        label: 'Threshold',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(246,40,3,0.4)',
        borderColor: 'rgba(246,40,3,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(246,40,3,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(246,40,3,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 1,
        data: thresholdArray,
      }
    ],
  };

  return (
    <div>
      <div >
          <CChart type="line" datasets={line.datasets} options={options} labels={line.labels} style={{width: "1400px", height: "300px"}} />
        </div>
    </div>
  );
}

export default DiskGraph;